document.addEventListener('DOMContentLoaded', () => {

    // Manejador de pestañas (Tabs)
    const tabContainer = document.querySelector('.tab-nav');
    if (tabContainer) {
        tabContainer.addEventListener('click', (e) => {
            if (e.target && e.target.matches('.tab-btn')) {
                const tabId = e.target.dataset.tab;

                document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
                document.querySelectorAll('.tab-content-custom').forEach(content => content.classList.remove('active'));

                e.target.classList.add('active');
                document.getElementById(tabId).classList.add('active');
            }
        });
    }

    // Función para copiar al portapapeles (AHORA ES MULTI-IDIOMA)
    window.copyToClipboard = function(text, button) {
        if (!navigator.clipboard) {
            // Fallback para navegadores antiguos
            copyTextFallback(text, button);
            return;
        }
        navigator.clipboard.writeText(text).then(() => {
            updateButtonText(button);
        }).catch(err => {
            console.error('No se pudo copiar el texto: ', err);
        });
    }

    function updateButtonText(button) {
        // Lee los textos desde los atributos data-* del botón
        const originalText = button.dataset.originalText;
        const copiedText = button.dataset.copiedText;

        button.innerText = copiedText; // Muestra "Copiado!" en el idioma correcto
        button.disabled = true;

        setTimeout(() => {
            button.innerText = originalText; // Vuelve al texto original "Copiar"
            button.disabled = false;
        }, 2000);
    }

    function copyTextFallback(text, button) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            updateButtonText(button);
        } catch (err) {
            console.error('Fallback: No se pudo copiar', err);
        }
        document.body.removeChild(textArea);
    }

    // Fetch para obtener las IPs reales (evita caché)
    const realtimeContainer = document.getElementById('ip-realtime-container');
    if (realtimeContainer) {
        const locale = document.documentElement.lang || 'es';

        // Intentamos obtener las traducciones de los atributos data o usamos fallbacks
        const labels = {
            ipv4: realtimeContainer.dataset.labelIpv4 || 'IPv4',
            ipv6: realtimeContainer.dataset.labelIpv6 || 'IPv6',
            copy: realtimeContainer.dataset.labelCopy || 'Copiar',
            copied: realtimeContainer.dataset.labelCopied || 'Copiado!',
            notAvailable: realtimeContainer.dataset.labelNotAvailable || 'No disponible'
        };

        const apiUrl = (locale === 'es') ? '/api/real-ip' : `/${locale}/api/real-ip`;

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                let html = '';

                // Generar bloque IPv6
                if (data.ipv6) {
                    html += `
                        <a href="/${locale}/ip/${data.ipv6}" class="text-decoration-none w-100" style="max-width: 600px;">
                            <div class="position-relative card card-featured card-featured-primary d-inline-block px-4 py-3 w-100">
                                <span class="d-block text-muted mb-1 text-start">${labels.ipv6}</span>
                                <h2 class="mb-0 text-break">
                                    <span class="ip-link">${data.ipv6}</span>
                                </h2>
                                <button class="btn btn-outline-primary btn-sm position-absolute top-0 end-0 mt-2 me-2 copy-btn"
                                        data-original-text="${labels.copy}"
                                        data-copied-text="${labels.copied}"
                                        onclick="event.preventDefault(); copyToClipboard('${data.ipv6}', this)">
                                    ${labels.copy}
                                </button>
                            </div>
                        </a>
                    `;
                } else {
                    html += `
                        <div class="position-relative card card-featured card-featured-primary d-inline-block px-4 py-3 w-100" style="max-width: 600px;">
                            <span class="d-block text-muted mb-1 text-start">${labels.ipv6}</span>
                            <h2 class="mb-0 ip-unavailable">${labels.notAvailable}</h2>
                            <button class="btn btn-outline-primary btn-sm position-absolute top-0 end-0 mt-2 me-2" disabled>
                                ${labels.copy}
                            </button>
                        </div>
                    `;
                }

                // Generar bloque IPv4
                if (data.ipv4) {
                    html += `
                        <a href="/${locale}/ip/${data.ipv4}" class="text-decoration-none w-100" style="max-width: 600px;">
                            <div class="position-relative card card-featured card-featured-primary d-inline-block px-4 py-3 w-100">
                                <span class="d-block text-muted mb-1 text-start">${labels.ipv4}</span>
                                <h2 class="mb-0 text-break">
                                    <span class="ip-link">${data.ipv4}</span>
                                </h2>
                                <button class="btn btn-outline-primary btn-sm position-absolute top-0 end-0 mt-2 me-2 copy-btn"
                                        data-original-text="${labels.copy}"
                                        data-copied-text="${labels.copied}"
                                        onclick="event.preventDefault(); copyToClipboard('${data.ipv4}', this)">
                                    ${labels.copy}
                                </button>
                            </div>
                        </a>
                    `;
                } else {
                    html += `
                        <div class="position-relative card card-featured card-featured-primary d-inline-block px-4 py-3 w-100" style="max-width: 600px;">
                            <span class="d-block text-muted mb-1 text-start">${labels.ipv4}</span>
                            <h2 class="mb-0 ip-unavailable">${labels.notAvailable}</h2>
                            <button class="btn btn-outline-primary btn-sm position-absolute top-0 end-0 mt-2 me-2" disabled>
                                ${labels.copy}
                            </button>
                        </div>
                    `;
                }

                realtimeContainer.innerHTML = html;
            })
            .catch(error => {
                console.error('Error obteniendo IP real:', error);
                realtimeContainer.innerHTML = '<div class="alert alert-danger">Error al cargar la IP real.</div>';
            });
    }
});
